import { Base } from './_base';

export class CallBackend extends Base {
  constructor(item) {
    super(item);
  }
}
